<template lang="pug">
//- TODO: add this lines in file "index.html" part is "head"
  <link href="https://js.bepaid.by/cse/v.1.0.0/begateway-cse.min.js" rel="preload" as="script">
  <script src="https://js.bepaid.by/cse/v.1.0.0/begateway-cse.min.js"></script>
section
  template(v-if="typeof begateway === 'object'")
    form.inner-form(method="POST", action="#handler", id="begateway-encrypted-form")
      .inner-form__secure
        slot
        span Мы гарантируем безопасность оплаты.
        span Платёж совершается в зашифрованном виде и обрабатывается исключительно банком.
        span Используется 256-битное шифрование для повышенной безопасности платежа.

      .inner-form__item
        input(v-model="value.num", data-encrypted-name="encrypted_number",
          hidden, autocomplete="off")
        the-mask.inner-form__input(
          v-model="value.num",
          :mask=`[
            '#### #### #### #### ###',
            '#### #### #### ####',
            '#### #### #### ###',
          ]`,
          :masked="false",
          autocomplete="off",
          placeholder="Номер карты")

      .inner-form__item
        the-mask.inner-form__input.inner-form__input-thrid(
          v-model="value.month"
          :mask="['M#']",
          :masked="false",
          :tokens="myTokens",
          autocomplete="off",
          data-encrypted-name="encrypted_exp_month",
          placeholder="ММ")

        the-mask.inner-form__input.inner-form__input-thrid(
          v-model="value.year"
          :mask="['20Y#']",
          :masked="false",
          :tokens="myTokens",
          autocomplete="off",
          data-encrypted-name="encrypted_exp_year",
          placeholder="ГГГГ")

        the-mask.inner-form__input.inner-form__input-thrid(
          v-model="value.cvv"
          :mask="['###', '####']",
          :masked="false",
          autocomplete="off",
          data-encrypted-name="encrypted_verification_value",
          placeholder="CVV")

      .inner-form__item
        the-mask.inner-form__input(
          v-model="value.owner"
          :mask="['WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW']",
          :masked="false",
          :tokens="myTokens",
          autocomplete="off",
          data-encrypted-name="encrypted_holder",
          placeholder="IVAN IVANOV")
      .inner-form__item
        button.button.button_primary(type="button", style="width: 100%", @click="enc"
        ) Добавить карту
</template>

<script>
import { TheMask } from 'vue-the-mask';

function sleep(time = 1) {
  return new Promise((resolve) => setTimeout(() => resolve(), time * 1000));
}

export default {
  name: 'CardFormComponent',
  components: {
    TheMask,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        num: '',
        month: '',
        year: '',
        cvv: '',
        owner: '',
      }),
      required: false,
    },
    public: {
      type: String,
      default: '',
      required: false,
    },
  },
  data: () => ({
    myTokens: {
      M: {
        pattern: /[0-1]/,
      },
      '#': {
        pattern: /[0-9]/,
      },
      Y: {
        pattern: /[2-9]/,
      },
      W: {
        pattern: /[a-zA-Z\s.]/,
        transform: (v) => v.toLocaleUpperCase(),
      },
    },
    begateway: null,
  }),
  mounted() {
    this.waitBP();
  },
  methods: {
    async waitBP(cb) {
      if (typeof BeGatewayCSE !== 'function' || !this.public) {
        await sleep(0.5);
        this.waitBP();
        cb && cb();
        return;
      }
      if (typeof this.begateway !== 'object' || !this.public) {
        await sleep(0.5);
        this.waitBP();
        cb && cb();
        return;
      }
      // eslint-disable-next-line
      this.begateway = new BeGatewayCSE(this.public);
    },
    enc() {
      if (typeof this.begateway !== 'object') {
        this.waitBP(this.enc);
        return;
      }
      this.begateway.encrypt('begateway-encrypted-form');
      const names = [
        'encrypted_holder',
        'encrypted_number',
        'encrypted_exp_year',
        'encrypted_exp_month',
        'encrypted_verification_value',
        'credit_card_last_4',
      ];
      const form = document.getElementById('begateway-encrypted-form');
      const fields = Array.prototype.filter.call(form, (e) => e.name && names.includes(e.name));
      const encryptedCreditCard = {};

      for (let i = 0; i < fields.length; i += 1) {
        encryptedCreditCard[fields[i].name] = fields[i].value;
      }
      this.$emit('encrypted', encryptedCreditCard);
    },
  },
};
</script>

<style lang="scss">
.inner-form {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  min-width: 340px;
  max-width: 440px;
  padding: 20px;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
  margin-bottom: 20px;
  position: relative;
  &__item {
    width: 100%;
    display: flex;
    &:not(:last-of-type) {
      margin-bottom: 25px;
    }
  }

  &__input {
    transition: all 0.3s;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #f0efec;
    box-shadow: none;
    box-sizing: border-box;
    color: #393939;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    height: 44px;
    outline: none;
    padding: 0 24px;
    width: 100%;
    flex: 1;
    &-thrid {
      width: 31%;
      flex: unset;
      margin: 0 1.75%;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    &::placeholder {
      color: #7b7b7b;
    }
    &:focus {
      border-color: #8200ff;
    }
  }

  &__secure {
    margin-top: -5px;
    font-size: 12px;
    line-height: 125%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 20px;
    span {
      color: #333;
      opacity: .5;
      &:first-child {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
      svg {
        margin-right: 10px;
        path {
          fill: #3db21b;
        }
      }
    }
  }
}
</style>
